<section #host id="ar" class="ar" [style.--count]="objects.length" aria-labelledby="ar-title">
  <div #pin class="ar__pin" [class.is-dragging]="dragging()">
    <header class="ar__head">
      <p class="ar__kicker">Try it first,</p>
      <h2 id="ar-title" class="ar__title">in your own room</h2>
    </header>

    <!-- one small box per chair: the strip slides sideways as the page scrolls, or when it is dragged -->
    <div #strip class="ar__strip">
      @for (o of objects; track o.id; let i = $index) {
        <button
          type="button"
          class="thumb"
          [style.--i]="i"
          [style.--backdrop]="o.backdrop"
          [attr.aria-label]="'Show ' + o.label"
          [attr.aria-current]="i === active() ? 'true' : null"
          [attr.tabindex]="i === active() ? -1 : null"
          (click)="goTo(i)"
        >
          <img [src]="o.image" alt="" width="960" height="960" loading="lazy" decoding="async" draggable="false" />
        </button>
      }
    </div>

    <!-- the big box: the chair in the middle of the strip — a live 3D model once that has loaded -->
    <div #frame class="ar__frame">
      <div
        class="ar__window"
        [class.is-live]="live()"
        [class.is-touched]="touched()"
        [class.has-ar]="arMode() !== null && arMode() !== 'none'"
      >
        @for (o of objects; track o.id; let i = $index) {
          <figure class="slide" [class.is-active]="i === active()" [style.--i]="i" [style.--backdrop]="o.backdrop">
            <img [src]="o.image" [alt]="o.alt" width="960" height="960" loading="lazy" decoding="async" draggable="false" />
            <figcaption class="slide__label"><span>0{{ i + 1 }}</span>{{ o.label }}</figcaption>
          </figure>
        }

        <model-viewer
          #viewer
          class="ar__viewer"
          ar
          ar-modes="webxr scene-viewer quick-look"
          ar-scale="fixed"
          ar-placement="floor"
          loading="eager"
          camera-controls
          touch-action="pan-y"
          disable-zoom
          disable-pan
          disable-tap
          field-of-view="24deg"
          camera-target="auto 0.48m auto"
          min-camera-orbit="auto 35deg auto"
          max-camera-orbit="auto 88deg auto"
          interpolation-decay="80"
          auto-rotate-delay="2500"
          rotation-per-second="24deg"
          interaction-prompt="none"
          environment-image="neutral"
          shadow-intensity="1"
          shadow-softness="1"
          exposure="1"
        >
          <!-- model-viewer shows this button only on devices that can run AR -->
          <button slot="ar-button" type="button" class="ar__launch">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 2.5 20 7v10l-8 4.5L4 17V7z" /><path d="M4 7l8 4.5L20 7" /><path d="M12 11.5v10" />
            </svg>
            View in your room
          </button>
        </model-viewer>

        <p class="ar__hint" aria-hidden="true">Drag to rotate · tap for price</p>

        <!-- opens when the chair is tapped -->
        <div class="ar__price" [class.is-open]="priceOpen()" [attr.aria-hidden]="priceOpen() ? null : 'true'" role="status">
          <button type="button" class="ar__price-close" aria-label="Close price" [tabindex]="priceOpen() ? 0 : -1" (click)="priceOpen.set(false)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m7 7 10 10M17 7 7 17" /></svg>
          </button>
          <p class="ar__price-name">{{ current().label }}</p>
          <p class="ar__price-now">{{ current().price }}</p>
          <p class="ar__price-sub">
            <s>{{ current().mrp }}</s>
            <span>{{ current().off }}% off</span>
          </p>
          <a class="ar__price-cta" href="#enquire" [tabindex]="priceOpen() ? 0 : -1">Enquire now</a>
        </div>
      </div>
    </div>

    <p class="sr-only" aria-live="polite">{{ objects[active()].label }}, {{ active() + 1 }} of {{ objects.length }}</p>
  </div>
</section>
